import script from "./OneOffItems.vue?vue&type=script&setup=true&lang=js"
export * from "./OneOffItems.vue?vue&type=script&setup=true&lang=js"

import "./OneOffItems.vue?vue&type=style&index=0&id=16be3fd5&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16be3fd5"]])

export default __exports__